import React from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const NotFound = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, md: 12 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, md: 6 },
          border: '1px solid rgba(55, 65, 81, 0.14)',
          borderRadius: 4,
          background: 'linear-gradient(180deg, #FFFFFF 0%, #F9FAFB 100%)',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" sx={{ fontSize: { xs: '3rem', md: '4.5rem' }, mb: 1, color: '#1F2937' }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ mb: 2, color: '#1F2937' }}>
          Page not found
        </Typography>
        <Typography variant="body1" sx={{ color: '#6B7280', maxWidth: 560, mx: 'auto', mb: 4 }}>
          The page you are looking for may have moved or no longer exists. Use the links below to continue browsing InnoVate.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button component={RouterLink} to="/" variant="contained">
            Go Home
          </Button>
          <Button component={RouterLink} to="/games" variant="outlined">
            Browse Games
          </Button>
          <Button component={RouterLink} to="/contact" variant="outlined">
            Contact Us
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFound;
